import UserFieldActionList from "./user-action-list-field";
import FieldLinkText       from "components/layout/fields/link-text-field";

const UserFields = {
    TitleLink       : FieldLinkText,
    ActionList      : UserFieldActionList
}

export default UserFields;